import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Tab from "@mui/material/Tab";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Jobs from "./Jobs";
import CompletedJobs from "./CompletedJobs";
import { useLocation } from "react-router-dom";


const JobsDashboard = () => {
  
  
  const location = useLocation()
  
  useEffect(()=>{
    if(location.state?.defaultTab){
      setValue(location.state.defaultTab)
    }
  },[location.state])
  
  const defaultTab = location?.state?.defaultValue || "1"
  const [value, setValue] = useState(defaultTab);
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });

  return (
    <div className="text-sm font-thin px-2">
      <ThemeProvider theme={theme}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="job tabs">
              <Tab label="Pending Jobs" value="1" />
              <Tab label="Completed Jobs (Verified)" value="2" />
            </TabList>
          </Box>

          <TabPanel value="1">
            <Jobs />
          </TabPanel>
          <TabPanel value="2">
            <CompletedJobs />
          </TabPanel>
        </TabContext>
      </ThemeProvider>
    </div>
  );
};

export default JobsDashboard;
